import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  selector: 'app-fullscreen-loader',
  styleUrls: ['./fullscreen-loader.component.scss'],
  imports: [MatProgressSpinnerModule],
  template: `
    <div class="fullscreen-loader position-fixed top-0 bottom-0 start-0 end-0 align-items-center d-flex justify-content-center">
      <mat-spinner></mat-spinner>
    </div>
  `,
})
export class FullscreenLoaderComponent {}
